import {Component, inject, Input} from '@angular/core';
import {
    ChecklistClient,
    ChecklistComplianceScoreQuery,
    ChecklistConditionQuery,
    GetAttendanceScoreQuery,
    IMyScoreShiftQuery,
    IncidentReportQuery,
    IncidentReportsClient,
    MyScoreClient,
    NextViewScoreQuery,
    PermissionType,
    ProductivityClient,
} from '@services';
import {DoughnutChartComponent} from '../../../components/library/doughnut-chart/doughnut-chart.component';
import {attendancePalette, attendanceTimeOffTypes} from '../../attendance/my-score/my-score.component';
import {nextViewPalette} from '../../productivity/next-view/next-view-score/next-view-score.component';
import {checklistCompliancePalette} from '../../safety/checklist-compliance/checklist-compliance.component';
import {checklistConditionPalette} from '../../safety/checklist-condition/checklist-condition.component';
import {incidentReportPalette} from '../../safety/incident-reports/incident-report-score/incident-report-score.component';
import {DashboardAccess} from '../dashboard-access';
import {DashboardCardComponent} from '../dashboard-card/dashboard-card.component';

@Component({
    selector: 'app-dashboard-our-team',
    imports: [DoughnutChartComponent, DashboardCardComponent],
    templateUrl: './dashboard-our-team.component.html',
})
export class DashboardOurTeamComponent {
    @Input() from: Date;
    @Input() to: Date;

    protected access = inject(DashboardAccess);
    private myScoreClient = inject(MyScoreClient);
    private productivityClient = inject(ProductivityClient);
    private checklistClient = inject(ChecklistClient);
    private incidentReportsClient = inject(IncidentReportsClient);

    protected readonly palettes = {
        attendance: attendancePalette(),
        efficiency: nextViewPalette(),
        checklistCompliance: checklistCompliancePalette(),
        checklistCondition: checklistConditionPalette(),
        incidentReports: incidentReportPalette(),
    };

    protected readonly attendanceTimeOffTypes = attendanceTimeOffTypes;

    protected readonly userIds = {
        attendance: this.access.attendanceUserId(),
        checklistCompliance: this.access.ownUnlessManage(PermissionType.ChecklistCompliance),
        checklistCondition: this.access.ownUnlessManage(PermissionType.ChecklistCondition),
        incidentReports: this.access.ownUnlessManage(PermissionType.IncidentReports),
    };

    protected loadAttendance = (query: IMyScoreShiftQuery) =>
        this.myScoreClient.getAttendanceScore(new GetAttendanceScoreQuery(query));

    protected loadEfficiency = (query: IMyScoreShiftQuery) =>
        this.productivityClient.getNextViewScore(new NextViewScoreQuery(query));

    protected loadChecklistCompliance = (query: IMyScoreShiftQuery) =>
        this.checklistClient.getChecklistComplianceScore(new ChecklistComplianceScoreQuery(query));

    protected loadChecklistCondition = (query: IMyScoreShiftQuery) =>
        this.checklistClient.getChecklistConditionScore(new ChecklistConditionQuery(query));

    protected loadIncidents = (query: IMyScoreShiftQuery) =>
        this.incidentReportsClient.getIncidentReportScore(new IncidentReportQuery({...query, isObservations: false}));

    protected loadObservations = (query: IMyScoreShiftQuery) =>
        this.incidentReportsClient.getIncidentReportScore(new IncidentReportQuery({...query, isObservations: true}));
}
